module.exports = __webpack_public_path__ + "static/media/facebook-pink-on-blue.4deb93ba.svg";